<template>
  <div class="filter-bar bg-lighter rounded p-2 p-sm-3 mb-3">
    <div class="filter-bar__row">
      <slot />
      <div v-if="active" class="filter-field filter-field--action">
        <button
          type="button"
          class="btn btn-outline-primary filter-bar__clear-all"
          @click="$emit('clear')"
        >Clear all filters</button>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * Panel that holds a server-list's filter controls (Horses now; Drafts / Members next):
 * a light band that lays the controls out in one wrapping row and shows "Clear all filters"
 * when `active`. Tabs and search stay outside it, where each page already had them.
 *
 * Slot in FilterMultiselect / FilterRadioGroup — they share the `.filter-field` box, and
 * `.filter-bar__row` bottom-aligns each wrapped line so a label-less field (checkbox,
 * clear-all button) lines up with a labelled field's control when they share a row, with
 * no extra markup needed when a label-less field ends up alone on its own row.
 *
 *   <filter-bar :active="hasActiveFilters" @clear="clearFilters">
 *     <filter-multiselect ... />
 *     <filter-radio-group ... />
 *   </filter-bar>
 */
export default {
  name: 'FilterBar',
  props: {
    // true when any filter is set — toggles the "Clear all filters" button
    active: { type: Boolean, default: false }
  }
}
</script>

<style>
/* Not scoped: shared layout for the slotted FilterMultiselect / FilterRadioGroup boxes. */
.filter-bar__row {
  display: flex;
  flex-wrap: wrap;
  /* Bottom-align each wrapped line: a label-less field (checkbox, clear-all) then sits flush
     with a labelled field's control when they share a row, and flush with the top when it
     wraps onto a row of its own — no breakpoint needed either way. */
  align-items: flex-end;
  gap: 0.75rem 1.25rem;
}

.filter-field {
  display: flex;
  flex-direction: column;
  min-width: 190px;
}

.filter-field--action {
  min-width: 0;
}

.filter-field__label {
  display: flex;
  align-items: baseline;
  min-height: 1.5rem;
  margin-bottom: 0.25rem;
  font-weight: 700;
  white-space: nowrap;
}

/* Row where the actual control lives — fixed height so radios line up with the selects. */
.filter-field__control {
  display: flex;
  align-items: center;
  min-height: 40px;
}

.filter-bar__clear-all {
  align-self: flex-start;
  height: 40px;
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/components/filters/FilterBar.vue